import { colors } from '@mui/material';

const white = '#FFFFFF';
// const BekoMavi = '#007DBA';
const ArcelikSari = '#FF9800';
const siyah = '#424242';

export default {
  primary: {
    contrastText: ArcelikSari,
    // dark: colors.indigo[900],
    // main: colors.indigo[500],
    // light: colors.indigo[100]
    dark: ArcelikSari,
    main: ArcelikSari,
    light: ArcelikSari
  },
  secondary: {
    contrastText: ArcelikSari,
    dark: siyah,
    main: siyah,
    light: siyah
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400]
  },
  // Fixed dark-shade tokens (not tied to light/dark mode) used by several
  // shared card/chart components for borders, gradients and label colors.
  dark: {
    light: '#bdc8f0',
    main: '#29314f',
    dark: '#212946',
    800: '#1a223f',
    900: '#111936'
  },
  text: {
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[600],
    link: colors.blue[600]
  },
  link: colors.blue[800],
  icon: colors.blueGrey[600],
  background: {
    default: '#F4F6F8',
    paper: white
  },
  divider: colors.grey[200]
};
